import Immutable from 'immutable';
import { ProjectGroupEdit } from 'records/ProjectGroupEdit';

export interface RawBatchProjectGroupsEdit {
  projectid: string;
  groupEdits: ProjectGroupEdit[];
}

export interface BatchProjectGroupsEditData {
  projectid: string;
  groupEdits: ProjectGroupEdit[];
}

const defaultValues: BatchProjectGroupsEditData = {
  projectid: '',
  groupEdits: [],
};

export const BatchProjectGroupsEditFactory = Immutable.Record(
  defaultValues,
  'BatchProjectGroupsEdit'
);

export class BatchProjectGroupsEdit extends BatchProjectGroupsEditFactory {
  static deserialize(
    rawBatchProjectGroupsEdit: RawBatchProjectGroupsEdit
  ): BatchProjectGroupsEdit {
    return new BatchProjectGroupsEdit({
      ...rawBatchProjectGroupsEdit,
    });
  }

  serialize(): RawBatchProjectGroupsEdit {
    return this.toJS();
  }
}
